import axios from 'axios';
import Cookies from 'js-cookie';

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Authorization: `Token ${getToken()}`
  }
});
export const apiCard = axios.create({
  baseURL: process.env.REACT_APP_API_CARD_URL
});

if (process.env.NODE_ENV === 'development') {
  window.api = api;
}

export function getToken() {
  return Cookies.get('auth');
}

export function getClaims() {
  return localStorage.getItem('claims');
}

export function setToken(token) {
  if (token) {
    api.defaults.headers['Authorization'] = `Token ${token}`;
    Cookies.set('auth', token, { expires: 1 });
  } else {
    delete api.defaults.headers['Authorization'];
    Cookies.remove('auth');
  }

  return token;
}

export function setClaims(claims) {
  if (claims) {
    localStorage.setItem('claims', claims);
  } else {
    localStorage.removeItem('claims');
  }

  return claims;
}
